import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { connect }          from 'react-redux';
import { push }             from 'connected-react-router';
import Modal                from '../Modal';
import EmailUpdateForm      from './EmailUpdateForm';
import * as modal           from '../../reducers/modalReducer';
import { rootPageUri }      from '../../config/uri';
import { verifyEmail }      from '../../services/email';
import { RESULT_CODE }      from '../../const/result_code_const';

class EmailUpdateFormModal extends Component {
  state = {
    isVerificationSent: false,
    verificationError: '',
    isLoading: false,
  }

  onCloseRequest = () => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.hideModal();
  }

  discardError = () => {
    this.setState({
      verificationError: '',
    });
  }

  setProgress = (isLoading) => {
    this.setState({
      isLoading,
    });
  }

    handleSubmit = (values) => {
      this.setProgress(true);

      verifyEmail(values.email).then((response) => {
        const {
          resultCode,
          resultReason,
        } = response.data;

        if (resultCode === RESULT_CODE.SUCCESS) {
          this.setState({
            isVerificationSent: true,
          });
        } else {
          this.setState({
            verificationError: resultReason,
          });
        }
      }).catch((e) => {
        console.error(e);
        this.props.hideModal();
      }).finally(() => {
        this.setProgress(false);
      });
    }

    render() {
      const {
        isVerificationSent,
        verificationError,
        isLoading,
      } = this.state;

      return (
        <Modal
          isOpened
          paddingTop="65px"
          overlayTop={0}
          closeOnOverlayClick
          closeOnOutsideClick={false}
          onClose={this.onCloseRequest}
        >
          <EmailUpdateForm
            isVerificationSent={isVerificationSent}
            verificationError={verificationError}
            onCloseRequest={this.onCloseRequest}
            onSubmit={this.handleSubmit}
            discardError={this.discardError}
            isLoading={isLoading}
          />
        </Modal>
      );
    }
}

const mapDispatchToProps = dispatch => ({
  openMainPage: () => dispatch(push(rootPageUri)),
  hideModal: () => dispatch(modal.hideModal()),
});

EmailUpdateFormModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(EmailUpdateFormModal);



// WEBPACK FOOTER //
// ./src/components/EmailUpdateFormModal/EmailUpdateFormModal.jsx